<template>
	<Popup
		v-model="selfDisplay"
		title="修改文章"
		confirmBtnText="修改"
		@confirmClick="handleUpdateClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>标题</span>
				<el-input v-model="title" placeholder="标题"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="titleTip"><i class="b_icon"></i>请输入标题</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>副标题</span>
				<el-input v-model="subTitle" placeholder="副标题"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="subTitleTip"><i class="b_icon"></i>请输入副标题</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>上传图片</span>
				<div v-if="!post" class="b_upload b_inline_block">
					<el-button type="primary">点击上传</el-button>
					<input type="file" accept="image/*" @change="handlePostUpload"/>
					<span class="b_upload_tip">请上传jpg或者png图片！！！</span>
				</div>
				<div v-if="post" class="b_upload b_inline_block" style="border: 1px solid #ccc;">
					<img :src="post" alt="" style="">
					<i @click="handlePostDelete"></i>
				</div>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="postTip"><i class="b_icon"></i>请上传图片</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>分类</span>
				<el-select v-model="type" placeholder="请选择" style="width: 100%;">
					<el-option v-for="v in types" :key="v.id" :value="v.id" :label="v.name"></el-option>
				</el-select>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>类型</span>
				<el-select v-model="category" placeholder="请选择" style="width: 100%;">
					<el-option v-for="v in appArticleCategory" :key="v.id" :value="v.id" :label="v.name"></el-option>
				</el-select>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #F56C6C;">*</span>主商品：</span>
				<div>
					<el-select class="b_inp" v-model="productDiseaseValue" placeholder="请选择疾病" style="width: 200px;margin-right: 20px;" @change="handleProductDiseaseChange">
						<el-option v-for="v in productDisease" :key="v.id" :label="v.name" :value="v.id"></el-option>
					</el-select>
					<el-select class="b_inp" v-model="productGoodsValue" placeholder="请选择商品" style="width: 200px;margin-right: 20px;">
						<el-option v-for="v in productGoods" :key="v.id" :label="v.name" :value="v.id"></el-option>
					</el-select>
					<el-button type="primary" @click="handleProductAdd">添加</el-button>
				</div>
				<div v-if="product.id" style="margin-top: 10px;">
					<el-tag :disable-transitions="false" style="margin: 0 10px 10px 0;">{{ product.name }}</el-tag>
				</div>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="productTip"><i class="b_icon"></i>请添加商品</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #F56C6C;">*</span>推荐商品：</span>
				<div>
					<el-select class="b_inp" v-model="recommendsDiseaseValue" placeholder="请选择疾病" style="width: 200px;margin-right: 20px;" @change="handleRecommendsDiseaseChange">
						<el-option v-for="v in recommendsDisease" :key="v.id" :label="v.name" :value="v.id"></el-option>
					</el-select>
					<el-select class="b_inp" v-model="recommendsGoodsValue" placeholder="请选择商品" style="width: 200px;margin-right: 20px;">
						<el-option v-for="v in recommendsGoods" :key="v.id" :label="v.name" :value="v.id"></el-option>
					</el-select>
					<el-button type="primary" @click="handleRecommendAdd">添加</el-button>
				</div>
				<div v-if="recommends.length" style="margin-top: 10px;">
					<el-tag v-for="v in recommends" :key="v.id" closable :disable-transitions="false" style="margin: 0 10px 10px 0;" @close="handleRecommendDelete(v.id)">{{ v.name }}</el-tag>
				</div>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="recommendsTip"><i class="b_icon"></i>请添加商品</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>内容</span>
				<editor v-model="content"></editor>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="contentTip"><i class="b_icon"></i>请编辑内容</template></div>
		</div>
	</Popup>
</template>

<script>
	import { mapState } from 'vuex';
	import Api from '../../../../../../../api/index.js';
	import BaseMethods from '../../../../../../../assets/js/base.js';
	
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			types: {
				type: Array,
				default() { return []; }
			},
			obj: {
				type: Object,
				default() { return {}; }
			},
			diseaseAndGoods: {
				type: Array,
				default() { return []; }
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				
				title: '',
				subTitle: '',
				post: '',
				type: '',
				category: '',
				product: {},
				productDisease: [],
				productDiseaseValue: '',
				productGoods: [],
				productGoodsValue: '',
				recommends: [],
				recommendsDisease: [],
				recommendsDiseaseValue: '',
				recommendsGoods: [],
				recommendsGoodsValue: '',
				content: '',
				titleTip: false,
				subTitleTip: false,
				postTip: false,
				productTip: false,
				recommendsTip: false,
				contentTip: false
			}
		},
		computed: {
			...mapState([
				'appArticleCategory'
			])
		},
		methods: {
			// 获取文章详情
			getArticleInfo() {
				const that = this;
				that.loading = true;
				Api.viewAppArticle(that.obj.id).then((res) => {
					if (res.data.success) {
						let data = res.data.data;
						let recommends = [];
						data.postGoods.forEach(v => {
							recommends.push({
								id: v.goodsId,
								name: v.goodsName
							});
						});
						that.loading = false;
						that.title = data.postTitle;
						that.subTitle = data.postSummaryContent;
						that.post = data.postImg;
						that.type = data.catId;
						that.category = data.postTag;
						that.product = {
							id: data.postGoodsMain.goodsId,
							name: data.postGoodsMain.goodsName
						};
						that.productDisease = that.diseaseAndGoods;
						that.productDiseaseValue = that.productDisease[0].id || '';
						that.productGoods = that.diseaseAndGoods.length ? that.diseaseAndGoods[0].goods : [];
						that.productGoodsValue = that.productGoods[0].id || '';
						that.recommends = recommends;
						that.recommendsDisease = that.diseaseAndGoods;
						that.recommendsDiseaseValue = that.recommendsDisease[0].id || '';
						that.recommendsGoods = that.diseaseAndGoods.length ? this.diseaseAndGoods[0].goods : [];
						that.recommendsGoodsValue = that.recommendsGoods[0].id || '';
						that.content = data.postContent;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 切换主商品疾病
			handleProductDiseaseChange() {
				this.diseaseAndGoods.forEach(v => {
					if (this.productDiseaseValue == v.id) {
						this.productGoods = v.goods;
						this.productGoodsValue = this.productGoods[0].id || '';
					}
				});
			},
			// 切换推荐商品疾病
			handleRecommendsDiseaseChange() {
				this.diseaseAndGoods.forEach(v => {
					if (this.recommendsDiseaseValue == v.id) {
						this.recommendsGoods = v.goods;
						this.recommendsGoodsValue = this.recommendsGoods[0].id || '';
					}
				});
			},
			// 添加主商品
			handleProductAdd() {
				this.productGoods.forEach(v => {
					if (v.id == this.productGoodsValue) {
						this.product = {
							id: v.id,
							name: v.name
						};
					}
				});
			},
			// 添加推荐商品
			handleRecommendAdd() {
				let index = -1;
				let name = '';
				let clone_list = [...this.recommends];
				this.recommendsGoods.forEach(v => {
					if (v.id == this.recommendsGoodsValue) {
						name = v.name;
					}
				});
				clone_list.forEach((v, i) => {
					v.id == this.recommendsGoodsValue && (index = i);
				});
				index != -1 && clone_list.splice(index, 1);
				this.recommends = [...clone_list, {id: this.recommendsGoodsValue, name: name}];
			},
			// 删除推荐商品
			handleRecommendDelete(id) {
				let index = -1;
				this.recommends.forEach((v, i) => {
					v.id == id && (index = i);
				});
				index != -1 && this.recommends.splice(index, 1);
			},
			// 点击修改
			handleUpdateClick() {
				if (!this.title.trim()) {
					this.titleTip = true;
					return false;
				} else {
					this.titleTip = false;
				}
				if (!this.subTitle.trim()) {
					this.subTitleTip = true;
					return false;
				} else {
					this.subTitleTip = false;
				}
				if (!this.product.id) {
					this.productTip = true;
					return false;
				} else {
					this.productTip = false;
				}
				if (!this.recommends.length) {
					this.recommendsTip = true;
					return false;
				} else {
					this.recommendsTip = false;
				}
				if (!this.content.trim()) {
					this.contentTip = true;
					return false;
				} else {
					this.contentTip = false;
				}
				this.update();
			},
			// 修改
			update() {
				const that = this;
				that.loading = true;
				let recommendsIds = '';
				that.recommends.forEach(v => {
					recommendsIds += `${ v.id },`;
				});
				recommendsIds && (recommendsIds = recommendsIds.slice(0, recommendsIds.length - 1));
				let requestData = {
					id: that.obj.id,
					catId: that.type,
					postTitle: that.title,
					postSummaryContent: that.subTitle,
					postTag: that.category,
					postContent: that.content,
					postImg: that.post,
					postGoodsMain: that.product.id,
					postGoods: recommendsIds
				};
				Api.updateAppArticle(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 上传图片
			handlePostUpload(e) {
				const that = this;
				BaseMethods.uploadMultiImg(e, (base64, imgs_type, imgs_name) => {
					that.uploadPost(base64[0], imgs_type[0], imgs_name[0]);
				}, (msg) => {
					that.$message.error(msg);
				});
			},
			// 删除上传的图片
			handlePostDelete() {
				this.post = '';
			},
			// 上传图片
			uploadPost(base64, img_type, fileName) {
				const that = this;
				that.loading = true;
				let postName = `${ new Date().getTime() }_${ fileName }`;
				let requestData = {
					base: base64,
					picName: postName,
					type: 'uGateWayUrl'
				};
				Api.uploadPic(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.post = res.data.data.imgUrl;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.getArticleInfo();
				} else {
					this.loading = false;
					this.title = '';
					this.subTitle = '';
					this.post = '';
					this.type = '';
					this.category = '';
					this.product = {};
					this.productDisease = [];
					this.productDiseaseValue = '';
					this.productGoods = [];
					this.productGoodsValue = '';
					this.recommends = [];
					this.recommendsDisease = [];
					this.recommendsDiseaseValue = '';
					this.recommendsGoods = [];
					this.recommendsGoodsValue = '';
					this.content = '';
					this.titleTip = false;
					this.subTitleTip = false;
					this.postTip = false;
					this.productTip = false;
					this.recommendsTip = false;
					this.contentTip = false;
				}
			}
		}
	}
</script>

<style>
</style>
